module.exports = require("@bechtel/client-assets/dist/images/filter.svg");